import { TaskListContext } from './context';

export const useTaskListContext = () => TaskListContext.hook();
